"use client";

import { useEffect } from "react";

/**
 * Last-resort error boundary — fires when a root layout itself throws.
 * Because no layout is in scope here, we must render our own <html>/<body>.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[global-error]", error);
  }, [error]);

  return (
    <html lang="pt-BR" data-theme="light">
      <body>
        <main style={{ padding: "80px 24px", maxWidth: 720, margin: "0 auto", fontFamily: "system-ui, sans-serif" }}>
          <p style={{ textTransform: "uppercase", letterSpacing: "0.08em", color: "#6b7e9f", fontSize: 12 }}>
            erro · {error.digest ?? "—"}
          </p>
          <h1 style={{ fontSize: 36, margin: "12px 0 16px" }}>Algo deu errado.</h1>
          <p style={{ color: "#445069", marginBottom: 24 }}>
            Tivemos um problema ao renderizar esta página. A equipe já foi notificada.
          </p>
          <div style={{ display: "flex", gap: 12 }}>
            <button
              onClick={() => reset()}
              type="button"
              style={{ background: "#0B1F3A", color: "#fff", border: 0, padding: "10px 16px", borderRadius: 6, cursor: "pointer" }}
            >
              Tentar de novo
            </button>
            {/* Global error boundary fires before the router is fully mounted —
                use a plain <a> so navigation always works, even if Link's runtime
                isn't available. */}
            {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
            <a
              href="/"
              style={{ border: "1px solid #cdd6e4", padding: "10px 16px", borderRadius: 6, color: "#0B1F3A", textDecoration: "none" }}
            >
              Voltar ao início
            </a>
          </div>
        </main>
      </body>
    </html>
  );
}
